import { Link } from 'react-router-dom';

import { HOME_ROUTE, LOGIN_ROUTE } from '../constants';

/**
 * The way back from a page a mailed link opens — `/email/verify`, `/invitations/accept` — to the
 * visitor's portal or to sign in. `/` lands by kind, so the way back
 * names no portal.
 */
export function DoorBackLink({ isAuth }: { isAuth: boolean }) {
  return (
    <p className="mt-6 text-center text-sm text-muted-foreground">
      <Link to={isAuth ? HOME_ROUTE : LOGIN_ROUTE} className="hover:text-[var(--color-royal-blue)]">
        {isAuth ? 'Back to your portal' : 'Back to sign in'}
      </Link>
    </p>
  );
}
